import { createContext, useContext, useState } from "react"

const GlobalContext = createContext({})

export default function useGlobalContext() {
  return useContext(GlobalContext)
}

export function GlobalContextProvider({ children }) {
  const [cursorType, setCursorType] = useState("")
  const [showMenu, setShowMenu] = useState(false)
  const [activeLink, setActiveLink] = useState(0)

  function changeCursor(type) {
    setCursorType(type)
  }

  return (
    <GlobalContext.Provider
      value={{
        cursorType,
        changeCursor,
        showMenu,
        setShowMenu,
        activeLink,
        setActiveLink,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
